import { graphql, StaticQuery } from "gatsby"
import React, { useLayoutEffect } from "react"

var size;

function BANNER() {

  useLayoutEffect (()=>{
    console.warn('BANNER useLayoutEffect');
    console.log('BANNER useLayoutEffect ready');

    try {
      //window.jQuery('.banner_home').css('width','600px')
      // window.jQuery('.banner_container').slick.setPosition();

      window.jQuery(
          '.banner_container').not(
          '.slick-initialized').slick({
        autoplay: true,
        infinite: true,
        autoplaySpeed: 6000,
        arrows: false,
        fade: true,
        slidesToShow: 1,
        dots: false,
      });
      // window.jQuery('.banner_container').slick('unslick').slick('reinit').slick();;
      setTimeout(function () { window.jQuery('.banner_container').slick('refresh'); }, 1000);

    } catch (error) {
      console.warn('Error BANNER useLayoutEffect', error);
    }

    //window.jQuery('.banner_container').css('max-width', parseInt(100/size)+"%")
    // var regStrContent = 'http[s]*:\/\/(?!cdn)[a-z0-9A-Z\.]*'+process.env.GATSBY_WPHOST+'\/wp-content\/';
    // var regContent = new RegExp(regStrContent,'g');
    return () => {
  }});


  return (
    <StaticQuery
      query={sdetailsQuery}
      render={data => {
        size = data.www.banners.nodes.length;
        console.warn('banner data', data);
        /*const metaDescription =
          description || data.site.siteMetadata.description
        const titleText = title
          ? `${title} | ${data.site.siteMetadata.title}`
          : data.site.siteMetadata.title*/


        return (
            <div className="banner_home" id="banner_home" >
            {
              data.www.banners.nodes
              .map(function (banner) {
                return    <div key={banner.bannerId} id={banner.slug} style={{padding: "10px", width: (parseInt(100/size)+"%")}} className={"banner_container "+banner.slug}>
                              { banner.banner1_url !== null && (<a href={banner.banner1_url}>
                                <img
                                  style={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    height: "auto",
                                    backgroundSize: "cover",
                                    backgroundImage: "url("+banner.banner1_image+")"}}
                                  src={banner.banner1_image}
                                  alt=""
                                >

                                </img>
                              </a>)}
                              { banner.banner2_url !== null  && (<a href={banner.banner2_url}>
                                <img
                                  style={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    height: "auto",
                                    backgroundSize: "cover",
                                    backgroundImage: "url("+banner.banner2_image+")"}}
                                  src={banner.banner2_image}
                                  alt=""
                                >

                                </img>
                              </a>)}
                              { banner.banner3_url !== null  && (<a href={banner.banner3_url}>
                                <img
                                  style={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    height: "auto",
                                    backgroundSize: "cover",
                                    backgroundImage: "url("+banner.banner3_image+")"}}
                                  src={banner.banner3_image}
                                  alt=""
                                >

                                </img>
                              </a>)}
                              { banner.banner4_url !== null  && (<a href={banner.banner4_url}>
                                <img
                                  style={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    height: "auto",
                                    backgroundSize: "cover",
                                    backgroundImage: "url("+banner.banner4_image+")"}}
                                  src={banner.banner4_image}
                                  alt=""
                                >

                                </img>
                              </a>)}
                          </div>
              })
            }
            </div>
        )


      }}
    />
  )
}

export default BANNER

const sdetailsQuery = graphql`
  query sDefaultBannerQuery {
    www {
      banners(where: {status: PUBLISH, hasPassword: false}) {
      nodes {
         bannerId
         title
         slug
         banner1_image
         banner1_url
         banner2_image
         banner2_url
         banner3_image
         banner3_url
         banner4_image
         banner4_url
      }
    }
  }
  }
`


/*SEO.defaultProps = {
  lang: `es`,
  meta: [],
  keywords: [],
}*/

/*SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}*/
